import { useEffect, useState } from "react";
import { api, apiError, deDate } from "../../lib/api";
import { toast } from "sonner";
import { Input } from "../../components/ui/input";

const STATUSES = ["trial", "aktiv", "zahlung_ausstehend", "gesperrt", "gekuendigt"];
const STATUS_LABELS = { trial: "Testphase", aktiv: "Aktiv", zahlung_ausstehend: "Zahlung ausstehend", gesperrt: "Gesperrt", gekuendigt: "Gekündigt" };

export default function AdminTenants() {
  const [tenants, setTenants] = useState([]);
  const [plans, setPlans] = useState([]);
  const [q, setQ] = useState("");

  const load = () => api.get(`/admin/tenants?q=${encodeURIComponent(q)}`).then((r) => setTenants(r.data));
  useEffect(() => { load(); api.get("/admin/plans").then((r) => setPlans(r.data)); }, []);

  const update = async (id, patch) => {
    try {
      await api.put(`/admin/tenants/${id}`, patch);
      toast.success("Aktualisiert.");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-6" data-testid="admin-tenants-page">
      <div className="flex justify-between items-end flex-wrap gap-3">
        <div>
          <div className="text-xs font-mono uppercase tracking-wider text-zinc-500">Plattform</div>
          <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight mt-1">Unternehmen</h1>
        </div>
        <Input placeholder="Suchen…" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
          className="w-64 bg-white border-zinc-200 text-zinc-900" data-testid="admin-tenants-search" />
      </div>

      <div className="bg-white border border-zinc-200 rounded-xl shadow-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[900px]">
          <thead><tr className="border-b border-zinc-200 text-left">
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">Unternehmen</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">Ansprechpartner</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">Tarif</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">Status</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">Registriert</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">KI/Monat</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500">Mitarbeiter</th>
          </tr></thead>
          <tbody className="divide-y divide-zinc-50">
            {tenants.map((t) => (
              <tr key={t.id} className="hover:bg-zinc-50" data-testid={`tenant-row-${t.company_name}`}>
                <td className="px-5 py-3"><div className="font-medium">{t.company_name}</div><div className="text-xs text-zinc-500">{t.city}</div></td>
                <td className="px-5 py-3 text-zinc-400 text-xs">{t.owner ? <>{t.owner.first_name} {t.owner.last_name}<br /><span className="font-mono">{t.owner.email}</span></> : "–"}</td>
                <td className="px-5 py-3">
                  <select value={t.plan_key} onChange={(e) => update(t.id, { plan_key: e.target.value })} data-testid={`tenant-plan-${t.company_name}`}
                    className="bg-white border border-zinc-300 rounded-lg px-2 py-1 text-xs">
                    {plans.map((p) => <option key={p.key} value={p.key}>{p.name}</option>)}
                  </select>
                </td>
                <td className="px-5 py-3">
                  <select value={t.status} onChange={(e) => update(t.id, { status: e.target.value })} data-testid={`tenant-status-${t.company_name}`}
                    className="bg-white border border-zinc-300 rounded-lg px-2 py-1 text-xs">
                    {STATUSES.map((s) => <option key={s} value={s}>{STATUS_LABELS[s]}</option>)}
                  </select>
                </td>
                <td className="px-5 py-3 text-zinc-400 text-xs">{deDate(t.created_at)}</td>
                <td className="px-5 py-3 font-mono text-xs">{t.ki_used_month}</td>
                <td className="px-5 py-3 font-mono text-xs">{t.user_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
